<template>
  <div>
    <div class="text-center" v-if="loading">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>
    <div v-else>
      <div>
        <div v-if="tabela">
          <div class="row">
            <p>
              <strong>Contato de Recado/Emergência -</strong> Informe ao menos 3 contatos do tipo recado, 
              sendo pelo menos 1 familiar e 1 não familiar: amigo(a), conhecido(a), vizinho(a).
            </p>
          </div>
          <div class="row">
            <div>
              <b-table
                responsive="sm"
                :items="dadosContatos"
                :fields="camposContatos"
                per-page="1000"
                striped
              >
                <template #cell(options)="data">
                  <div class="d-flex justify-content-end">
                    <b-button
                      size="sm"
                      class="me-1"
                      variant="primary"
                      @click="editarContato(data.item)"
                      data-tooltip="Editar"
                      data-tooltip-location="left"
                    >
                      <i class="mdi mdi-pencil"></i>
                    </b-button>
                    <b-button
                      size="sm"
                      class="me-1"
                      variant="danger"
                      @click="excluirContato(data.item)"
                      data-tooltip="Excluir"
                      data-tooltip-location="left"
                    >
                      <i class="mdi mdi-trash-can"></i>
                    </b-button>
                  </div>
                </template>
              </b-table>
            </div>
            <div>
              <div class="mt-1 d-flex justify-content-end">
                <b-button variant="info" class="mt-5 mb-3" @click="incluir()">
                  <i class="mdi mdi-plus"></i>
                  Incluir
                </b-button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="mt-1 d-flex justify-content-between">
              <b-button
                class="mt-1 me-1"
                @click="navegar('enderecos', false)"
                data-tooltip="Voltar"
                data-tooltip-location="bottom"
              >
                <i class="mdi mdi-arrow-left-circle font-size-15"></i>
              </b-button>
              <b-button
                variant="primary"
                class="mt-1 me-1"
                @click="navegar('email', true)"
                data-tooltip="Próximo"
                data-tooltip-location="bottom"
              >
                <i class="mdi mdi-arrow-right-circle font-size-15"></i>
              </b-button>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="row">
            <div :class="selectCdTipo.cd_tipo == 6 ? 'col-md-3' : 'col-md-6'">
              <b-form-group class="mb-3" label="Tipo de contato">
                <multiselect
                  v-model="selectCdTipo"
                  placeholder="Selecione"
                  :show-labels="false"
                  label="nm_tipo"
                  :options="optionCdTipo"
                  @input="updateStPrincipal"
                />
              </b-form-group>
            </div>
            <div :class="selectCdTipo.cd_tipo == 6 ? 'col-md-3' : 'col-md-6'">
              <b-form-group class="mb-3" label="Telefone">
                <b-form-input
                  v-mask="mascaraTelefone(telefone)"
                  v-model="telefone"
                  type="text"
                  trim
                  autocomplete="off"
                ></b-form-input>
              </b-form-group>
            </div>
            <div class="row col-md-6" v-if="selectCdTipo.cd_tipo == 6">
              <div class="col-md-6">
                <b-form-group class="mb-3" label="O que o contato é seu?">
                  <multiselect
                    v-model="selectGrauContato"
                    placeholder="Selecione"
                    :show-labels="false"
                    label="nm_contato"
                    :options="optionGrauContato"
                  />
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group class="mb-3" label="Nome Contato Recado">
                  <b-form-input
                    v-model="nomeContato"
                    type="text"
                    trim
                    autocomplete="off"
                    maxlength="60"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <b-form-group
                label="Observação"
                label-for="Observação"
                class="mb-3"
              >
                <b-form-textarea
                  for="Observação"
                  v-model="observacao"
                  :maxlength="200"
                  class="col-md-12"
                ></b-form-textarea>
                <div class="text-center">
                  <p
                    v-if="observacao"
                    class="badge position-absolute"
                    :class="{
                      'bg-success': observacao.length < 200,
                      'bg-danger': observacao.length === 200,
                    }"
                  >
                    {{ observacao.length }} / 200
                  </p>
                </div>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="d-flex align-items-center">
              <b-form-checkbox
                v-model="stPrincipal"
                unchecked-value="N"
                value="S"
                plain
                :disabled="disabledPrincipal || selectCdTipo.cd_tipo == 6"
              >
                Contato Principal
              </b-form-checkbox>

              <b-form-checkbox
                v-model="isWhatsapp"
                :value="true"
                :unchecked-value="false"
                plain
                class="ms-4"
              >
                WhatsApp
              </b-form-checkbox>
            </div>
          </div>
          <div class="row">
            <div class="mt-1 d-flex justify-content-between">
              <b-button
                variant="secondary"
                data-tooltip="Voltar"
                data-tooltip-location="bottom"
                class="mt-1 me-1"
                @click="tabela = !tabela"
              >
                <i class="mdi mdi-arrow-left-circle font-size-15"></i>
              </b-button>
              <b-button
                variant="success"
                class="mt-1 me-1"
                :disabled="disabledSalvar"
                @click="salvar"
                data-tooltip="Salvar"
                data-tooltip-location="bottom"
              >
                <i class="mdi mdi-content-save"></i>
                <b-spinner
                  variant="primary"
                  small
                  class="ms-2"
                  v-if="loadingSalvar"
                ></b-spinner>
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
const capitalizeString = (str) => {
  return str
    .split(" ")
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
};
export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      telefone: "",
      sqTelefone: "",
      nomeContato: "",
      sqContato: "",
      cdTipo: "",
      optionGrauContato: [],
      optionCdTipo: [],
      selectGrauContato: "",
      selectCdTipo: "",
      stPrincipal: "N",
      isWhatsapp: false,
      observacao: "",
      tabela: true,
      dadosContatos: [],
      camposContatos: [
        {
          key: "nr_telefone",
          label: "Telefone",
          formatter: (value, row, column) => {
            return "(" + column.nr_ddd + ")" + value;
          },
        },
        {
          key: "cd_tipo",
          label: "Tipo",
          formatter: (value) => {
            var cdTipo = this.optionCdTipo.find((el) => el.cd_tipo == value);
            return cdTipo ? cdTipo.nm_tipo : "";
          },
        },
        {
          key: "sq_contato_recado",
          label: "Relação",
          formatter: (value) => {
            var sqContato = this.optionGrauContato.find(
              (el) => el.sq_contato_recado == value
            );
            return sqContato ? sqContato.nm_contato : "";
          },
        },
        {
          key: "nm_contato_recado",
          label: "Nome Recado",
          formatter: (value) => {
            if (value) {
              if (value.length > 12) {
                return value.substring(0, 12) + "...";
              } else {
                return value;
              }
            } else {
              return "";
            }
          },
        },
        {
          key: "ds_obs",
          label: "Observação",
          formatter: (value) => {
            if (value) {
              if (value.length > 12) {
                return value.substring(0, 12) + "...";
              } else {
                return value;
              }
            } else {
              return "";
            }
          },
        },
        {
          key: "st_principal",
          label: "Principal",
          formatter: (value) => {
            return value == "S" ? "Sim" : "Não";
          },
        },
        {
          key: "options",
          label: "",
        },
      ],
      disabledSalvar: false,
      loadingSalvar: false,
      loading: true,
      disabledPrincipal: false,
    };
  },
  async created() {
    await this.buscarContatos();
  },
  methods: {
    async buscarContatos() {
      this.loading = true;
      try {
        const [telPessoaResponse, lkpRecadoResponse, lkpCdTipoResponse] =
          await Promise.all([
            this.$http.get("api/profileErp/contatos"),
            this.$http.get("api/cadastroCandidato/buscarLkpContatoRecado"),
            this.$http.get("api/cadastroCandidato/buscarTipoContato"),
          ]);

        this.optionCdTipo = (lkpCdTipoResponse.data || []).map((item) => ({
          ...item,
          cd_tipo: item.cd_tipo || item.id || item.Id,
          nm_tipo: capitalizeString(item.nm_tipo || item.Descricao || item.descricao || ""),
        }));

        const filteredContatos = (telPessoaResponse.data || []).filter(item => {
          if (item.TipoContato && item.TipoContato.TipoComunicacao === "E") {
            return false;
          }
          if (item.Descricao && item.Descricao.includes("@")) {
            return false;
          }
          return true;
        });

        this.dadosContatos = filteredContatos.map(item => {
          let ddd = item.nr_ddd || item.ddd || item.Ddd || "";
          let telefone = item.nr_telefone || item.telefone || item.Telefone || "";
          
          if (!ddd && !telefone && item.Descricao) {
            const digits = item.Descricao.replace(/\D/g, "");
            if (digits.length === 10 || digits.length === 11) {
              ddd = digits.substring(0, 2);
              telefone = digits.substring(2);
            } else {
              telefone = digits;
            }
          }
          const isPrincipal = item.Principal === true || item.principal === true || item.stPrincipal === "S" || item.st_principal === "S" || item.Principal === "S";
          const isWhatsapp = item.Whatsapp === true || item.whatsapp === true || item.Whatsapp === "S" || item.whatsapp === "S" || item.st_whatsapp === "S";

          return {
            ...item,
            nr_telefone: telefone,
            nr_ddd: ddd,
            cd_tipo: item.cd_tipo || item.cdTipo || item.idTipoContato || item.IdTipoContato || (item.TipoContato ? item.TipoContato.Id : 1),
            sq_contato_recado: item.sq_contato_recado || item.sqContatoRecado || item.idContatoRecado || item.IdContatoRecado || null,
            nm_contato_recado: item.nm_contato_recado || item.nmContatoRecado || item.nomeContatoRecado || item.NomeContatoRecado || "",
            sq_telefone: item.sq_telefone || item.sqTelefone || item.id || item.Id || "",
            ds_obs: item.ds_obs || item.dsObs || item.observacao || item.Observacao || "",
            st_principal: isPrincipal ? "S" : "N",
            principal: isPrincipal,
            Principal: isPrincipal,
            Whatsapp: isWhatsapp,
            whatsapp: isWhatsapp
          };
        });
        
        this.optionGrauContato = lkpRecadoResponse.data;
      } catch (error) {
        console.error("Erro ao buscar os contatos:", error);
      } finally {
        this.loading = false;
        this.tabela = true;
      }
    },
    mascaraTelefone(telefone) {
      const tiraMask = telefone.replace(/\D/g, "");
      return tiraMask.length === 11 ? "(##) #####-####" : "(##) ####-####";
    },
    async resolverIdTipoContatoRemote(telefoneStr) {
      let tiposRemote = [];
      try {
        const resp = await this.$http.get("api/profileErp/tipos-contato");
        if (resp.data && Array.isArray(resp.data)) {
          tiposRemote = resp.data;
        }
      } catch (err) {
        console.warn("Erro ao buscar tipos de contato do portal_api:", err);
      }

      if (tiposRemote.length === 0 && this.optionCdTipo) {
        tiposRemote = this.optionCdTipo;
      }

      // Buscar ID de Celular por Regex em UPPERCASE
      const itemCelular = tiposRemote.find((item) => {
        const str = (item.nm_tipo || item.Descricao || item.descricao || item.nm_tipo_contato || "").toString().toUpperCase();
        return /CELULAR|MOVEL|MÓVEL/.test(str);
      });
      const idCelular = parseInt(itemCelular?.Id || itemCelular?.id || itemCelular?.cd_tipo || 2);

      // Buscar ID de Fixo por Regex em UPPERCASE
      const itemFixo = tiposRemote.find((item) => {
        const str = (item.nm_tipo || item.Descricao || item.descricao || item.nm_tipo_contato || "").toString().toUpperCase();
        return /FIXO|RESIDENCIAL|COMERCIAL|TELEFONE/.test(str);
      });
      const idFixo = parseInt(itemFixo?.Id || itemFixo?.id || itemFixo?.cd_tipo || 3);

      // Analisar quantidade de dígitos do número isolando o DDD (se total for 10 ou 11 dígitos)
      const apenasNumeros = (telefoneStr || "").replace(/\D/g, "");
      let numeroSemDdd = apenasNumeros;
      if (apenasNumeros.length === 10 || apenasNumeros.length === 11) {
        numeroSemDdd = apenasNumeros.substring(2);
      }
      const qtdDigitos = numeroSemDdd.length;

      if (qtdDigitos === 8) {
        return idFixo;
      } else if (qtdDigitos === 9) {
        return idCelular;
      }

      return qtdDigitos <= 8 ? idFixo : idCelular;
    },
    async salvar() {
      if (!this.telefone) {
        this.$tools.alerta(
          "Por favor, para continuar preencha todos os campos",
          "warning"
        );
        return;
      }

      this.loading = true;

      // Consulta os tipos de contato remotos no portal_api e escolhe estritamente Fixo (8 dig) ou Celular (9 dig)
      const idTipoCalculado = await this.resolverIdTipoContatoRemote(this.telefone);
      const numeros = this.telefone.replace(/\D/g, "");
      const isPrincipalBool = Boolean(this.stPrincipal === "S" || this.stPrincipal === true || this.stPrincipal === "true");
      const isWhatsappBool = Boolean(this.isWhatsapp);

      const payload = {
        Ddd: numeros.substring(0, 2),
        ddd: numeros.substring(0, 2),
        NrDdd: numeros.substring(0, 2),
        nrDdd: numeros.substring(0, 2),
        
        Telefone: numeros.substring(2),
        telefone: numeros.substring(2),
        NrTelefone: numeros.substring(2),
        nrTelefone: numeros.substring(2),
        
        Principal: isPrincipalBool ? "S" : "N",
        principal: isPrincipalBool ? "S" : "N",
        StPrincipal: isPrincipalBool ? "S" : "N",
        stPrincipal: isPrincipalBool ? "S" : "N",
        
        IdTipoContato: idTipoCalculado,
        idTipoContato: idTipoCalculado,
        CdTipo: idTipoCalculado,
        cdTipo: idTipoCalculado,
        
        Observacao: this.observacao || "",
        observacao: this.observacao || "",
        DsObs: this.observacao || "",
        dsObs: this.observacao || "",
        
        // Novos campos mapeados para o portal_api (novo ERP)
        Descricao: numeros, // ddd + telefone
        Whatsapp: isWhatsappBool,
        whatsapp: isWhatsappBool
      };

      const isEdit = !!this.sqTelefone;
      const url = isEdit ? `api/profileErp/contatos/${this.sqTelefone}` : "api/profileErp/contatos";
      const requestAction = isEdit ? this.$http.put(url, payload) : this.$http.post(url, payload);

      requestAction
        .then(() => {
          this.$tools.alerta("Cadastrado com sucesso", "success");
          this.$emit("carregarNivelPerfil");
        })
        .catch((err) => {
          this.$tools.alerta(err.response?.data?.message || "Erro ao salvar contato no ERP", "error");
        })
        .finally(() => {
          this.loading = false;
          this.buscarContatos();
        });
    },
    incluir() {
      this.telefone = "";
      this.selectGrauContato = "";
      this.stPrincipal = "N";
      this.isWhatsapp = false;
      this.nomeContato = "";
      this.selectCdTipo = "";
      this.sqTelefone = "";
      this.observacao = "";
      this.sq_contato_recado = null;
      this.nm_contato_recado = "";
      this.tabela = false;
      this.disabledPrincipal = false;
    },
    editarContato(data) {
      var montaNumero = data.nr_ddd + data.nr_telefone;
      this.telefone = montaNumero;
      if (data.sq_contato_recado) {
        this.selectGrauContato = this.optionGrauContato.find(
          (el) => el.sq_contato_recado == data.sq_contato_recado
        );
        this.sq_contato_recado = data.sq_contato_recado;
      } else {
        this.sq_contato_recado = null;
      }
      const idTipoContato = data.cd_tipo || data.IdTipoContato || data.idTipoContato || (data.TipoContato ? data.TipoContato.Id : 1);
      this.selectCdTipo = this.optionCdTipo.find(
        (el) => el.cd_tipo == idTipoContato || el.id == idTipoContato
      ) || { cd_tipo: idTipoContato };
      this.nomeContato = data.nm_contato_recado || "";
      this.sqTelefone = data.sq_telefone || data.Id || data.id;
      const isPrincipal = data.st_principal === "S" || data.stPrincipal === "S" || data.principal === true || data.Principal === true || data.Principal === "S";
      this.stPrincipal = isPrincipal ? "S" : "N";
      this.isWhatsapp = data.Whatsapp === true || data.whatsapp === true || data.Whatsapp === "S" || data.whatsapp === "S" || data.st_whatsapp === "S";
      this.observacao = data.ds_obs || data.Observacao || data.observacao || "";
      this.disabledPrincipal = isPrincipal ? true : false;
      this.tabela = false;
    },
    excluirContato(data) {
      this.loading = true;
      this.$http
        .delete("api/profileErp/contatos/" + data.sq_telefone)
        .then(() => {
          this.$tools.alerta("Excluído com sucesso", "success");
          this.$emit("carregarNivelPerfil");
        })
        .catch((err) => {
          this.$tools.alerta(err.response?.data?.message || "Erro ao excluir contato no ERP", "error");
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
          this.buscarContatos();
        });
    },
    updateStPrincipal() {
      if (this.selectCdTipo.cd_tipo == 6) {
        this.stPrincipal = "N";
      }
    },
    navegar(nomeAba, direcao) {
      this.$emit("navegar", nomeAba, direcao);
    },
  },
};
</script>